@if (partner$ | async; as partner) {
    <section>
        <app-partner-basic [partner]="partner"></app-partner-basic>
    </section>
    @if (partner.stores) {
        <section class="my-11 my-xl-14">
            <app-partner-stores [stores]="partner.stores"></app-partner-stores>
        </section>
    }
    <div class="container-xxl">
        <h3 class="mb-6 fs-39 fw-700">{{ 'OUR_SALOON.our_partners.title' | translate }}</h3>
    </div>
    <section class="mb-11 mb-xl-14">
        <app-our-partners-logos></app-our-partners-logos>
    </section>
}
